export const hrLocale = {
    accept: 'Da',
    reject: 'Ne',
    // Calendar
    dayNames: ['Nedjelja', 'Ponedjeljak', 'Utorak', 'Srijeda', 'Četvrtak', 'Petak', 'Subota'],
    dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
    dayNamesMin: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
    monthNames: ['Siječanj', 'Veljača', 'Ožujak', 'Travanj', 'Svibanj', 'Lipanj', 'Srpanj', 'Kolovoz', 'Rujan', 'Listopad', 'Studeni', 'Prosinac'],
    monthNamesShort: ['Sij', 'Velj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro'],
    today: 'Danas',
    clear: 'Očisti',
    weekHeader: 'Tjedan',
    firstDayOfWeek: 0,
    dateFormat: 'mm/dd/yy', // Keeping the original format string as it is usually not localized
    weak: 'Slaba',
    medium: 'Srednja',
    strong: 'Jaka',
    passwordPrompt: 'Unesite lozinku',
    emptyFilterMessage: 'Nema pronađenih rezultata',
    emptyMessage: 'Nema pronađenih zapisa',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'], // File size units are usually kept as-is
    aria: {
        trueLabel: 'Da',
        falseLabel: 'Ne',
        nullLabel: 'Nije odabrano',
        star: '1 zvjezdica',
        stars: '{star} zvjezdice',
        selectAll: 'Odaberi sve',
        unselectAll: 'Poništi odabir',
        close: 'Zatvori',
        previous: 'Prethodno',
        next: 'Sljedeće',
        navigation: 'Navigacija',
        scrollTop: 'Pomakni na vrh',
        moveTop: 'Premjesti na vrh',
        moveUp: 'Premjesti gore',
        moveDown: 'Premjesti dolje',
        moveBottom: 'Premjesti na dno',
        moveToTarget: 'Premjesti na cilj',
        moveToSource: 'Premjesti na izvor',
        moveAllToTarget: 'Premjesti sve na cilj',
        moveAllToSource: 'Premjesti sve na izvor',
        pageLabel: 'Stranica {page}',
        firstPageLabel: 'Prva stranica',
        lastPageLabel: 'Zadnja stranica',
        nextPageLabel: 'Sljedeća stranica',
        previousPageLabel: 'Prethodna stranica',
        rowsPerPageLabel: 'Redova po stranici',
        jumpToPageDropdownLabel: 'Skoči na stranicu',
        jumpToPageInputLabel: 'Unesite broj stranice',
        selectRow: 'Odaberi red',
        unselectRow: 'Poništi odabir reda',
        expandRow: 'Proširi red',
        collapseRow: 'Sažmi red',
        showFilterMenu: 'Prikaži izbornik filtera',
        hideFilterMenu: 'Sakrij izbornik filtera',
        filterOperator: 'Operator filtera',
        filterConstraint: 'Ograničenje filtera',
        editRow: 'Uredi red',
        saveEdit: 'Spremi promjenu',
        cancelEdit: 'Odustani od promjene',
        listView: 'Prikaz liste',
        gridView: 'Prikaz mreže',
        slide: 'Slajd',
        slideNumber: '{slideNumber}',
        zoomImage: 'Povećaj sliku',
        zoomIn: 'Povećaj',
        zoomOut: 'Smanji',
        rotateRight: 'Rotiraj desno',
        rotateLeft: 'Rotiraj lijevo',
        // Additional components
        choose: 'Odaberi',
        upload: 'Učitaj',
        cancel: 'Poništi',
        remove: 'Ukloni',
        dateFormat: 'mm/dd/yy', // Keeping the original format string
        emptyMessage: 'Nema pronađenih podataka'
    }
}
